/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ProfileChoice
 */
export interface ProfileChoice {
    /**
     *
     * @type {string}
     * @memberof ProfileChoice
     */
    value: string;
    /**
     *
     * @type {string}
     * @memberof ProfileChoice
     */
    label: string;
}

/**
 * Check if a given object implements the ProfileChoice interface.
 */
export function instanceOfProfileChoice(value: object): value is ProfileChoice {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function ProfileChoiceFromJSON(json: any): ProfileChoice {
    return ProfileChoiceFromJSONTyped(json, false);
}

export function ProfileChoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileChoice {
    if (json == null) {
        return json;
    }
    return {

        'value': json['value'],
        'label': json['label'],
    };
}

  export function ProfileChoiceToJSON(json: any): ProfileChoice {
      return ProfileChoiceToJSONTyped(json, false);
  }

  export function ProfileChoiceToJSONTyped(value?: ProfileChoice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'value': value['value'],
        'label': value['label'],
    };
}
